__turbopack_context__.v({
  "icon": "Default-module__wqgbjG__icon",
  "inner": "Default-module__wqgbjG__inner",
  "message": "Default-module__wqgbjG__message",
  "toast": "Default-module__wqgbjG__toast",
  "wrapper": "Default-module__wqgbjG__wrapper",
});
